function checkRules(newPassword) {
    function length() {
        return newPassword.length >= 8;
    }

    var object1 = {
        list: $('#list1'),
        correct: false,
        rule: length(),
    };

    var object2 = {
        list: $('#list2'),
        correct: false,
        rule: strpbrk(newPassword, '!,;.&:-_+*~#§()[]<>|=?\"\'\\'),
    };

    var object3 = {
        list: $('#list3'),
        correct: false,
        rule: strpbrk(newPassword, "0123456789"),
    };

    var object4 = {
        list: $('#list4'),
        correct: false,
        rule: strpbrk(newPassword, "ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÜ"),
    };

    var object5 = {
        list: $('#list5'),
        correct: false,
        rule: strpbrk(newPassword, "abcdefghijklmnopqrstuvwxyzäöü"),
    };

    var objects = [object1, object2, object3, object4, object5];

    objects.forEach(function (object) {
        if (!object.rule) {
            object.list.removeClass('d-none');
            object.correct = false;
        } else {
            object.list.addClass('d-none');
            object.correct = true;
        }
    });

    var submitButton = $('#submit-button1');

    var allCorrect = objects.every(function (item) {
        return item.correct;
    });

    if (allCorrect) {
        console.log("true");
        submitButton.removeClass('disabled');
        submitButton.prop('disabled', false);
        return true;
    } else {
        console.log("false");
        submitButton.addClass('disabled');
        submitButton.prop('disabled', true);
        return false;
    }
}

export default checkRules;